import { f as r } from "./function-uncurry-this.js";
var a = r([].slice);
export { a };